import { z } from 'zod/v4';

import { normalizeNavigationWidgetArgs } from './navigation-widget-args.normalization';
import { partialNavigationWidgetDataSchema } from './partial-navigation-widget-data.schema';

/**
 * `navigation` widgets can only be created inside the site's header or footer — enforced by
 * `apps/mcp-backend` (there is no column-tree context here to check against), not by this schema.
 */
const createNavigationWidgetObjectSchema = z.object({
    columnId: z
        .string()
        .describe(
            'Id of the column to create the navigation widget in. Must be a column inside the site header ' +
                'or footer — call get_page_snapshot first to find one, or create_block with role: "header"/"footer".'
        ),
    index: z
        .number()
        .int()
        .min(0)
        .optional()
        .describe("Position within the column's widget list (0-based). Omit to append at the end."),
    data: partialNavigationWidgetDataSchema
        .optional()
        .describe('Navigation settings. Omit entirely to create one with the default 3-entry menu.'),
});

export const createNavigationWidgetArgsSchema = z.preprocess(
    normalizeNavigationWidgetArgs,
    createNavigationWidgetObjectSchema
);
